import Image from 'next/image'
import Link from 'next/link'
import Script from 'next/script'
import React from 'react'

import { Icon } from '@wartek-id/icon'
import { Text } from '@wartek-id/text'

import { useRoles } from 'utils/hooks/useRoles'

import ButtonKonsultasiDaring from './ButtonKonsultasiDaring'
import RoleAndRegionDetails from './RoleAndRegionDetails'
import UserDetails from './UserDetails'

interface DesktopNavbarProps {
  children?: React.ReactNode
}

export const DesktopNavbar = ({ children }: DesktopNavbarProps) => {
  const { isSuperAdminUser, isBknUser } = useRoles()

  return (
    <div className="sticky top-0 z-50">
      {isSuperAdminUser && (
        <div className="bg-primary p-2">
          <div className="flex justify-center gap-2">
            <Icon fontSize="sm" color="inverse">
              information
            </Icon>
            <Text variant="body-sm" color="inverse">
              Anda sedang masuk sebagai Super Admin dengan akses penuh ke
              seluruh sistem
            </Text>
          </div>
        </div>
      )}

      <nav
        data-testid="navbar"
        className="flex flex-row items-center justify-between bg-white px-12 py-3 shadow"
      >
        <div className="flex flex-row items-center">
          <Link href="/" aria-label="Logo" className="flex gap-3">
            <Image
              src="/images/logo-kemdikbud.png"
              alt="Kemdikbud"
              width={44}
              height={44}
            />
            <Image
              src="/images/logo-ruang-gtk.svg"
              alt="Ruang GTK"
              width={60}
              height={44}
            />
          </Link>
          <div className="ml-4">
            {children || <Text variant="heading-lg">SIM KSPSTK</Text>}
          </div>
        </div>

        <div className="flex flex-row items-stretch gap-4">
          {!isBknUser && <ButtonKonsultasiDaring />}

          {!isBknUser && <RoleAndRegionDetails />}

          <UserDetails />
        </div>
      </nav>

      <Script
        async
        src="https://embed.supergpt.id/widget.js?v=16"
        data-collection-id="ff3dc560dba9"
        data-offset-x="20"
        data-offset-y="20"
      />
    </div>
  )
}
